import initSearch from './js/algolia/search-algolia';

document.addEventListener( 'DOMContentLoaded', () => {

	const searchToggle = document.querySelector( '.js-searchToggle' );
	let isSearchInitialized = false;
	let searchInstance = null;

	/**
	 * Initialize search if not already initialized
	 * @return {void}
	 */
	const ensureSearchInitialized = () => {

		if ( !isSearchInitialized ) {

			searchInstance = initSearch();
			isSearchInitialized = true;

		}

	};

	/**
	 * Toggle search UI state
	 * @param {boolean} shouldOpen - Whether to open or close the search
	 */
	const toggleSearchUI = ( shouldOpen ) => {

		const searchBar = document.querySelector( '.js-searchBar' );
		const searchOverlay = document.querySelector( '.js-searchOverlay' );
		const searchInput = document.querySelector( '.opt-search__input' );
		const isSearchPage = new URLSearchParams( window.location.search ).has( 's' );

		if ( shouldOpen ) {

			searchBar.classList.add( 'is-active' );
			searchOverlay.classList.add( 'is-active' );
			searchToggle.setAttribute( 'aria-expanded', 'true' );
			if ( searchInput ) {

				searchInput.focus();

			}

		} else {

			searchBar.classList.remove( 'is-active' );
			searchOverlay.classList.remove( 'is-active' );
			searchToggle.setAttribute( 'aria-expanded', 'false' );

			// Only clear search input if we're not on the search results page
			if ( searchInput && !isSearchPage ) {

				searchInput.value = '';
				searchInput.dispatchEvent( new Event( 'input', { bubbles: true } ) );

			}

		}

	};

	// Initialize immediately if we're on the search results page
	const urlParams = new URLSearchParams( window.location.search );
	if ( urlParams.has( 's' ) ) {

		ensureSearchInitialized();

	}

	// Handle search toggle click
	if ( searchToggle ) {

		searchToggle.addEventListener( 'click', () => {

			ensureSearchInitialized();
			const isExpanded = searchToggle.getAttribute( 'aria-expanded' ) === 'true';
			toggleSearchUI( !isExpanded );

		} );

		// Handle overlay click for closing
		const searchOverlay = document.querySelector( '.js-searchOverlay' );
		if ( searchOverlay ) {

			searchOverlay.addEventListener( 'click', () => {

				toggleSearchUI( false );

			} );

		}

	}

} );
